// extracted by mini-css-extract-plugin
module.exports = {"carousel":"q_B","large":"q_C"};